module.exports = __webpack_public_path__ + "img/201128-1.2ca0da4f.jpeg";